import { render, staticRenderFns } from "./opinion-chart.vue?vue&type=template&id=ae563c96&"
import script from "./opinion-chart.vue?vue&type=script&lang=js&"
export * from "./opinion-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports